import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle" }, null, -1)
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = {
  key: 1,
  class: "p-error"
}
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "accountType" }, "Account Type", -1)
const _hoisted_16 = {
  key: 0,
  class: "p-field"
}
const _hoisted_17 = {
  key: 0,
  class: "p-error"
}
const _hoisted_18 = {
  key: 1,
  class: "p-field"
}
const _hoisted_19 = {
  key: 0,
  class: "p-error"
}
const _hoisted_20 = { class: "p-field" }
const _hoisted_21 = {
  key: 0,
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.productDialog,
    "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.productDialog) = $event)),
    style: { width: '50vw' },
    maximizable: true,
    position: "top",
    class: "p-fluid",
    modal: true,
    closable: true,
    onHide: _ctx.closeDialog
  }, _createSlots({
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", {
          for: "accountTitle",
          class: _normalizeClass({ 'p-error': _ctx.v$.accountTitle.$invalid && _ctx.submitted })
        }, "Name *", 2),
        _createVNode(_component_InputText, {
          id: "accountTitle",
          modelValue: _ctx.v$.accountTitle.$model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.accountTitle.$model) = $event)),
          modelModifiers: { trim: true },
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearErrors('account_title'))),
          class: _normalizeClass({ 'p-invalid': _ctx.v$.accountTitle.$invalid && _ctx.submitted}),
          autoFocus: ""
        }, null, 8, ["modelValue", "class"]),
        ( (_ctx.v$.accountTitle.$invalid && _ctx.submitted) || _ctx.v$.accountTitle.$pending.$response )
          ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.v$.accountTitle.$silentErrors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", {
          for: "contactNo",
          class: _normalizeClass({ 'p-error': (_ctx.v$.contactNo.$invalid && _ctx.submitted ) || _ctx.beErrors.hasOwnProperty('contact_no')})
        }, "Mobile No *", 2),
        _createVNode(_component_InputText, {
          id: "contactNo",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearErrors('contact_no'))),
          modelValue: _ctx.v$.contactNo.$model,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.contactNo.$model) = $event)),
          modelModifiers: { trim: true },
          class: _normalizeClass({ 'p-invalid': (_ctx.v$.contactNo.$invalid && _ctx.submitted) || _ctx.beErrors.hasOwnProperty('contact_no')}),
          placeholder: "9477xxxxxxx or 077xxxxxxx or 77xxxxxxx"
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.contactNo.$invalid && _ctx.submitted) || _ctx.v$.contactNo.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.v$.contactNo.$silentErrors[0].$message), 1))
          : _createCommentVNode("", true),
        (_ctx.beErrors.hasOwnProperty('contact_no'))
          ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.beErrors.hasOwnProperty('contact_no') ? _ctx.beErrors['contact_no'][0]:''), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", {
          for: "emailAddress",
          class: _normalizeClass({ 'p-error': (_ctx.v$.emailAddress.$invalid && _ctx.submitted )})
        }, "Email Address", 2),
        _createVNode(_component_InputText, {
          id: "emailAddress",
          modelValue: _ctx.v$.emailAddress.$model,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.emailAddress.$model) = $event)),
          modelModifiers: { trim: true },
          "aria-describedby": "email-error",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearErrors('email_address'))),
          class: _normalizeClass({ 'p-invalid': (_ctx.v$.emailAddress.$invalid && _ctx.submitted)})
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.emailAddress.$invalid && _ctx.submitted) || _ctx.v$.emailAddress.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.v$.emailAddress.$silentErrors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("label", {
          for: "nationalId",
          class: _normalizeClass({ 'p-error': (_ctx.v$.nationalId.$invalid && _ctx.submitted )})
        }, "National ID", 2),
        _createVNode(_component_InputText, {
          id: "nationalId",
          modelValue: _ctx.v$.nationalId.$model,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.nationalId.$model) = $event)),
          modelModifiers: { trim: true },
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearErrors('national_id'))),
          class: _normalizeClass({ 'p-invalid': (_ctx.v$.nationalId.$invalid && _ctx.submitted)})
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.nationalId.$invalid && _ctx.submitted) || _ctx.v$.nationalId.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.v$.nationalId.$silentErrors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", {
          for: "address",
          class: _normalizeClass({ 'p-error': (_ctx.v$.address.$invalid && _ctx.submitted )})
        }, "Address", 2),
        _createVNode(_component_InputText, {
          id: "address",
          modelValue: _ctx.v$.address.$model,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.address.$model) = $event)),
          modelModifiers: { trim: true },
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearErrors('address'))),
          class: _normalizeClass({ 'p-invalid': (_ctx.v$.address.$invalid && _ctx.submitted)})
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.address.$invalid && _ctx.submitted) || _ctx.v$.address.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.v$.address.$silentErrors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_Dropdown, {
          id: "accountType",
          modelValue: _ctx.item.accountType,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.accountType) = $event)),
          options: _ctx.profilerTypes,
          optionLabel: "key"
        }, null, 8, ["modelValue", "options"])
      ], 512), [
        [_vShow, this.profilerTypes.length > 1]
      ]),
      (_ctx.item.accountType.key === 'Supplier')
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("label", {
              for: "company",
              class: _normalizeClass({ 'p-error': (_ctx.v$.company.$invalid && _ctx.submitted )})
            }, "Company", 2),
            _createVNode(_component_InputText, {
              id: "company",
              modelValue: _ctx.v$.company.$model,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.company.$model) = $event)),
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clearErrors('company'))),
              class: _normalizeClass({ 'p-invalid': (_ctx.v$.company.$invalid && _ctx.submitted)})
            }, null, 8, ["modelValue", "class"]),
            ((_ctx.v$.company.$invalid && _ctx.submitted) || _ctx.v$.company.$pending.$response)
              ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_ctx.v$.company.$silentErrors[0].$message), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.item.accountType.key === 'Supplier')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("label", {
              for: "defaultExpiryAlertDuration",
              class: _normalizeClass({ 'p-error': (_ctx.v$.defaultExpiryAlertDuration.$invalid && _ctx.submitted )})
            }, "Expiry Notice Period (Days) *", 2),
            _createVNode(_component_InputText, {
              id: "defaultExpiryAlertDuration",
              modelValue: _ctx.v$.defaultExpiryAlertDuration.$model,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v$.defaultExpiryAlertDuration.$model) = $event)),
              placeholder: "",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clearErrors('default_expiry_alert_duration'))),
              class: _normalizeClass({ 'p-invalid': (_ctx.v$.defaultExpiryAlertDuration.$invalid && _ctx.submitted)})
            }, null, 8, ["modelValue", "class"]),
            ((_ctx.v$.defaultExpiryAlertDuration.$invalid && _ctx.submitted) || _ctx.v$.defaultExpiryAlertDuration.$pending.$response)
              ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(_ctx.v$.defaultExpiryAlertDuration.$silentErrors[0].$message), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("label", {
          for: "description",
          class: _normalizeClass({ 'p-error': (_ctx.v$.description.$invalid && _ctx.submitted )})
        }, "Description", 2),
        _createVNode(_component_InputText, {
          id: "description",
          modelValue: _ctx.v$.description.$model,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.v$.description.$model) = $event)),
          modelModifiers: { trim: true },
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.clearErrors('description'))),
          class: _normalizeClass({ 'p-invalid': (_ctx.v$.description.$invalid && _ctx.submitted)})
        }, null, 8, ["modelValue", "class"]),
        ((_ctx.v$.description.$invalid && _ctx.submitted) || _ctx.v$.description.$pending.$response)
          ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.v$.description.$silentErrors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 2
  }, [
    (!_ctx.previewOnly)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "Clear",
              icon: "pi pi-times",
              class: "p-button-text",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.clearProfile()))
            }),
            _createVNode(_component_Button, {
              type: "submit",
              label: "Save",
              icon: "pi pi-check",
              class: "p-button-primary",
              onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent"]))
            })
          ])
        }
      : undefined
  ]), 1032, ["visible", "onHide"]))
}